export enum OutgoingInvoiceContainsEnum {
  ALL = 'all_positions',
  DELIVERED = 'only_delivered_items',
}
